import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { Environment } from 'src/environments/environment.model';

import { SoilType } from '../models/soil-type.models';

@Injectable({
  providedIn: 'root',
})
export class SoilTypeService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  private readonly baseUrl = `${this.env.APIM_BASE_URL}/arable-service/soiltype`;

  getSoilTypes(): Observable<SoilType[]> {
    return this.http.get<SoilType[]>(this.baseUrl);
  }
}
